import { DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

import { Button } from '@/components/Button';
import { PresenceDialog } from '@/tracker/ui/PresenceDialog';

type Props = {
  title: string;
  text: string;
  /** Идёт запрос — повторно не жмём */
  disabled: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

/** Подтверждение необратимого удаления: красная кнопка «Удалить» */
const ConfirmDialog: React.FC<Props> = ({ title, text, disabled, onConfirm, onClose }) => (
  <PresenceDialog onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{text}</DialogContentText>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button variant="text" onClick={onClose}>
        Отмена
      </Button>
      <Button
        disabled={disabled}
        sx={{ backgroundColor: 'var(--danger-color)' }}
        onClick={onConfirm}
      >
        Удалить
      </Button>
    </DialogActions>
  </PresenceDialog>
);

export { ConfirmDialog };
